import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BruteForce} from "../BruteForce";
import {gsap} from "gsap";
import {BruteForceGameMode} from "../server/BruteForceGameMode";
import {BruteForceSound} from "../sound/BruteForceSound";

export class BruteForceBackgroundElements extends PIXI.Container implements StageLayer {

    private _mainFG: PIXI.Sprite;
    private _mainBG: PIXI.Sprite;
    private _fsBG: PIXI.Sprite;
    private _sfsBG: PIXI.Sprite;
    private _bgoverlay: PIXI.Sprite;
    private _maskedGraphic: PIXI.Graphics;


    constructor() {
        super();
        this.name = "BruteForceBackgroundElements";
        this.init();
    }

    public introBgTravel(): gsap.core.Timeline {
        const bgtl: gsap.core.Timeline = gsap.timeline();
        this._mainBG.position.set(490, 300);
        this._mainFG.position.set(620, 300);
        this._bgoverlay.alpha = 0;
        bgtl.add(() => {
            BruteForceSound.playTrack(BruteForceSound.REEL_CRASH)
        }, 0);
        bgtl.to(this._mainFG, {duration: 2, x: 120})
        bgtl.to(this._mainBG, {duration: 2, x: 290}, "<");
        bgtl.to(this._bgoverlay, {alpha: 0.6, duration: 2}, "<");
        bgtl.add(() => {
            BruteForceSound.stopSound(BruteForceSound.REEL_CRASH)
        }, ">")
        return bgtl;
    }

    public fsintroBgTravel(): gsap.core.Timeline {

        const transMainBG: PIXI.Sprite = new PIXI.Sprite(BruteForce.assetLoader.getTextures("transitionmainbackground")[0]);
        transMainBG.position.set(-70, 350);
        transMainBG.anchor.set(0.5, 0.5);
        transMainBG.name = "transitionMainBG";
        const pole: PIXI.Sprite = new PIXI.Sprite(BruteForce.assetLoader.getTextures("pole")[0]);

        pole.position.set(357, 350);
        pole.anchor.set(0.5, 0.5);
        pole.name = "pole";
        this.addChild(pole, transMainBG, this._fsBG, this._bgoverlay);

        const fsIntrotl: gsap.core.Timeline = gsap.timeline();

        this._fsBG.position.set(796, 350);
        this._bgoverlay.alpha = 0;
        fsIntrotl.add(() => {
            BruteForceSound.playTrack(BruteForceSound.REEL_CRASH)
        }, 0)
        fsIntrotl.to(transMainBG, {duration: 2, x: -509})
        fsIntrotl.to(pole, {duration: 2, x: -82}, "<")
        fsIntrotl.to(this._fsBG, {duration: 2, x: 357}, "<");
        fsIntrotl.to(this._bgoverlay, {alpha: 0.6, duration: 2}, "<");
        fsIntrotl.add(() => {
            BruteForceSound.stopSound(BruteForceSound.REEL_CRASH);
            this.removeChild(transMainBG, pole);
        }, ">")
        return fsIntrotl;
    }

    public sfsIntroBgTravel(): gsap.core.Timeline {
        const sfsIntroTl: gsap.core.Timeline = gsap.timeline();
        const maingroundCopy: PIXI.Sprite = new PIXI.Sprite(BruteForce.assetLoader.getTextures("transitionmainbackground")[0]);
        maingroundCopy.position.set(357, 350);
        maingroundCopy.anchor.set(0.5, 0.5);
        maingroundCopy.name = "maingorundCopy";
        const pipe: PIXI.Sprite = new PIXI.Sprite(BruteForce.assetLoader.getTextures("pipe")[0]);

        pipe.position.set(357, 720);
        pipe.anchor.set(0.5, 0.5);
        pipe.name = "pipe";
        this.addChild(pipe, maingroundCopy, this._bgoverlay);

        sfsIntroTl.add(() => {
            this._sfsBG.position.set(357, 1042);
            maingroundCopy.position.set(357, 350);
            pipe.position.set(357, 695);
            this._bgoverlay.alpha = 0;
            BruteForceSound.playTrack(BruteForceSound.REEL_CRASH);
        }, 0);

        sfsIntroTl.to(maingroundCopy, {duration: 2, y: -342});
        sfsIntroTl.to(pipe, {duration: 2, y: 3}, "<");
        sfsIntroTl.to(this._sfsBG, {duration: 2, y: 350}, "<");
        sfsIntroTl.to(this._bgoverlay, {alpha: 0.6, duration: 2}, "<");
        sfsIntroTl.add(() => {
            BruteForceSound.stopSound(BruteForceSound.REEL_CRASH);
            this.removeChild(maingroundCopy, pipe);
        }, ">");
        return sfsIntroTl;
    }

    public setMode(mode: string) {
        if (mode == BruteForceGameMode.FREESPIN) {
            this._mainBG.visible = false;
            this._mainFG.visible = false;
            this._sfsBG.visible = false;
            this._fsBG.visible = true;
        } else if (mode == BruteForceGameMode.FREESPIN_SUPER) {
            this._mainBG.visible = false;
            this._fsBG.visible = false;
            this._mainFG.visible = false;
            this._sfsBG.visible = true;
        } else {
            this._fsBG.visible = false;
            this._sfsBG.visible = false;
            this._mainBG.visible = true;
            this._mainFG.visible = true;
            this._mainBG.position.set(290, 300);
            this._mainFG.position.set(120, 300);
        }
    }

    private init() {

        this._mainBG = new PIXI.Sprite(BruteForce.assetLoader.getTextures("mainbackground")[0]);
        this._mainBG.position.set(290, 350);
        this._mainBG.anchor.set(0.5, 0.5);
        this._mainBG.name = "mainBg";

        this._mainFG = new PIXI.Sprite(BruteForce.assetLoader.getTextures("mainFG")[0]);
        this._mainFG.position.set(120, 350);
        this._mainFG.anchor.set(0.5, 0.5);
        this._mainFG.name = "mainFg";


        this._fsBG = new PIXI.Sprite(BruteForce.assetLoader.getTextures("fsbackground")[0]);
        this._fsBG.position.set(357, 350);
        this._fsBG.anchor.set(0.5, 0.5);
        this._fsBG.name = "fsBG";


        this._sfsBG = new PIXI.Sprite(BruteForce.assetLoader.getTextures("sfsbackground")[0]);
        this._sfsBG.position.set(357, 350);
        this._sfsBG.anchor.set(0.5, 0.5);
        this._sfsBG.name = "sfsBG";


        this.addChild(this._mainBG, this._mainFG, this._fsBG, this._sfsBG);


        this._bgoverlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._bgoverlay.name = "overlay";
        this._bgoverlay.tint = 0x000000;
        this._bgoverlay.alpha = 0.65;

        this._bgoverlay.width = 750;
        this._bgoverlay.height = 600;
        this._bgoverlay.position.set(360, 360);
        this._bgoverlay.anchor.set(0.5, 0.5);
        this.addChild(this._bgoverlay);

        this._maskedGraphic = new PIXI.Graphics();
        this._maskedGraphic.beginFill(0x9E99E9, 1);
        this._maskedGraphic.drawRect(0, 50, 720, 600);
        this._maskedGraphic.name="bgTravelMask"
        this.addChild(this._maskedGraphic);
        this.mask = this._maskedGraphic;


    }


}